import { ActionTypes } from 'modules/iterableGoals/ducks/actionTypes';
import { GoalAnalyticsData, GoalAnalyticsQuery } from 'modules/iterableGoals/types';

export const fetchGoalAnalyticsRequest = (queryData: GoalAnalyticsQuery) => ({
  type: ActionTypes.FETCH_GOAL_ANALYTICS_REQUEST,
  queryData,
});

export const fetchGoalAnalyticsResponse = (data: GoalAnalyticsData | Record<string, never>) => ({
  type: ActionTypes.FETCH_GOAL_ANALYTICS_RESPONSE,
  payload: data,
});

export const fetchGoalAnalyticsError = () => ({
  type: ActionTypes.FETCH_GOAL_ANALYTICS_ERROR,
});
